import { TypographyColor } from 'melp-design/components';
import { IntegrationStatus } from './integrations.types';

export const COLOR_BY_STATUS: Record<IntegrationStatus, TypographyColor> = {
  active: 'success',
  inactive: 'textSecondary',
};
